//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import webinarCategoriesQuery from '~/apollo/queries/webinars/webinars'
import webinarsPageHeaderQuery from '~/apollo/queries/webinars/page-header'

export default {
  mixins: [seo],
  apollo: {
    webinarsPageHeader: {
      query: webinarsPageHeaderQuery,
      prefetch: true
    },
    webinarCategories: {
      query: webinarCategoriesQuery,
      prefetch: true
    }
  },
  computed: {
    webinarsAccordionIndex () {
      return this.$store.getters['webinars/accordionIndex']
    }
  },
  created () {
    this.seoTitle = 'Training'
  }
}

